import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Clock } from "lucide-react";

interface InactivityWarningModalProps {
  open: boolean;
  timeRemaining: number;
  onStillHere: () => void;
  onLogout: () => void;
}

const formatTime = (ms: number): string => {
  const minutes = Math.floor(ms / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const InactivityWarningModal = ({
  open,
  timeRemaining,
  onStillHere,
  onLogout,
}: InactivityWarningModalProps) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 rounded-full bg-warning/10">
              <Clock className="h-6 w-6 text-warning" />
            </div>
            <AlertDialogTitle className="text-xl">
              Are you still there?
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-base space-y-3">
            <p>
              You've been inactive for a while. For your security, we'll log you out automatically.
            </p>
            <div className="flex items-center justify-center py-4">
              <div className="text-3xl font-bold text-foreground tabular-nums">
                {formatTime(timeRemaining)}
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              Click "I'm still here" to continue your session, or you'll be logged out when the timer reaches zero.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel onClick={onLogout}>
            Log me out
          </AlertDialogCancel>
          <AlertDialogAction onClick={onStillHere}>
            I'm still here
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
